import { useState } from "react";
import useCreate from '../../useCreate';
import toast from 'react-hot-toast';

const useDeleteIngredient = () => {
  const [ingredientId, setIngredientId] = useState(null);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);

  const { setDataToServer } = useCreate({
    url: 'ingredients/delete',
    refreshUrl: 'ingredients/list',
    onSuccess: () => {
      toast.success("Ingredient Deleted Successfully", {
        position: "top-right",
        duration: 3000
      });
      setDeleteModalOpen(false);
    }
  });

  const handleSubmit = (data) => {
    setDataToServer.mutate(data);
  };

  return {
    ingredientId,
    setIngredientId,
    isDeleteModalOpen,
    setDeleteModalOpen,
    handleSubmit,
  };
};

export default useDeleteIngredient;
